import React, { useMemo } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select';
import { normalizeTime24, parseTime24To12, time12To24 } from '../../utils/timeFormat';

const HOURS = Array.from({ length: 12 }, (_, i) => i + 1);
const MINUTES = Array.from({ length: 60 }, (_, i) => i);

export default function TimeInput12h({
  value = '',
  onChange,
  className = '',
  disabled = false,
  required = false,
  id,
  triggerClassName = 'bg-muted border-border',
}) {
  const normalized = normalizeTime24(value);
  const hasValue = Boolean(normalized);
  const { hour, minute, period } = useMemo(
    () => (hasValue ? parseTime24To12(normalized) : { hour: null, minute: null, period: null }),
    [hasValue, normalized],
  );

  const emit = (h, m, p) => {
    const nextHour = h ?? hour ?? 9;
    const nextMinute = m ?? minute ?? 0;
    const nextPeriod = p ?? period ?? 'AM';
    onChange?.(time12To24(nextHour, nextMinute, nextPeriod));
  };

  return (
    <div className={`flex gap-2 w-full ${className}`} id={id} data-required={required || undefined}>
      <Select
        value={hour != null ? String(hour) : undefined}
        onValueChange={(v) => emit(Number(v), minute, period)}
        disabled={disabled}
      >
        <SelectTrigger className={`flex-1 min-w-0 ${triggerClassName}`}>
          <SelectValue placeholder="Hr" />
        </SelectTrigger>
        <SelectContent className="bg-muted border-border max-h-48">
          {HOURS.map((h) => (
            <SelectItem key={h} value={String(h)}>{h}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={minute != null ? String(minute) : undefined}
        onValueChange={(v) => emit(hour, Number(v), period)}
        disabled={disabled}
      >
        <SelectTrigger className={`flex-1 min-w-0 ${triggerClassName}`}>
          <SelectValue placeholder="Min" />
        </SelectTrigger>
        <SelectContent className="bg-muted border-border max-h-48">
          {MINUTES.map((m) => (
            <SelectItem key={m} value={String(m)}>{String(m).padStart(2, '0')}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={period ?? undefined}
        onValueChange={(v) => emit(hour, minute, v)}
        disabled={disabled}
      >
        <SelectTrigger className={`flex-1 min-w-0 ${triggerClassName}`}>
          <SelectValue placeholder="AM/PM" />
        </SelectTrigger>
        <SelectContent className="bg-muted border-border">
          <SelectItem value="AM">AM</SelectItem>
          <SelectItem value="PM">PM</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
